// extracted by mini-css-extract-plugin
export default {"labelPhoto":"style_labelPhoto__PoN4g","iconPhoto":"style_iconPhoto__MRCTA","textPhoto":"style_textPhoto__upX6j"};